import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import Modal from "../../Modal";

import actions from "@/actions";
import { Spacer } from "@/components/common";
import { SubmitButton } from "@/components/common/SubmitButton";
import { ProcessSelectorGroup } from "@/components/matrix/Modal/ProcessSelectorGroup";
import { Process } from "@/models/matrix";

type Props = {
  process: Process;
  processes: Process[];
  onClose: () => void;
  onCompleted: () => void;
};

export const LockColumnEditor = ({ process, processes, onClose, onCompleted }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [fromProcess, setFromProcess] = useState<Process>();
  const [toProcess, setToProcess] = useState<Process>();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = () => {
    if (!fromProcess || !toProcess || toProcess.sort < fromProcess.sort) {
      // 両方に作業が選択されていない、または、順番が異なる場合はエラー
      return setError(t("invalid_lock_processes"));
    }
    const keyProcesses = processes.concat().filter((p) => fromProcess.sort <= p.sort && p.sort <= toProcess.sort);
    if (keyProcesses.some((p) => p.lock_flg)) {
      // ロック列が含まれる場合はエラー
      return setError(t("processes_include_lock"));
    }
    setError("");

    setLoading(true);
    dispatch(
      actions.lockProcess.createLockProcess(
        {
          lock_target_process_id: process.process_id,
          lock_key_process_ids: keyProcesses.map((p) => p.process_id),
        },
        () => {
          setLoading(false);
          onCompleted();
          onClose();
        },
        () => setLoading(false)
      )
    );
  };

  return (
    <Modal title={`${t("lock_setting")}：[${process.process_name}]`} closeHandler={onClose}>
      <div className="modal-body" style={{ paddingBottom: "10px" }}>
        <p className="text-center">
          <span>{t("lock_column_editor_description_1")}</span>
          <br />
          <span>{t("lock_column_editor_description_2")}</span>
        </p>
        <Spacer y="20px" />
        <div className="flex items-center justify-center mx-[20px]">
          <div className="w-240">
            <ProcessSelectorGroup processes={processes} onChange={(p) => setFromProcess(p)} />
          </div>
          <div className="mx-[15px]">〜</div>
          <div className="w-240">
            <ProcessSelectorGroup processes={processes} onChange={(p) => setToProcess(p)} />
          </div>
        </div>
        <div className="h-[20px] flex justify-center">{error && <p className="form-error-message">{t(error)}</p>}</div>
      </div>
      <div className={"modal-footer"}>
        <button data-test-id="button-column-editor-cancel" type="button" className="btn btn-gray" onClick={onClose}>
          {t("cancel")}
        </button>
        <SubmitButton data-test-id="button-column-editor-save" onClick={handleSubmit} loading={loading} />
      </div>
    </Modal>
  );
};
